
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agentdetail",
      function () {
        return require("private-next-pages/agentdetail.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agentdetail"])
      });
    }
  